"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlexView = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var clsx_1 = __importDefault(require("clsx"));
var React = __importStar(require("react"));
var propsFilter_1 = require("../../library/propsFilter");
var SharkMorphContext_1 = require("../../providers/SharkMorphContext");
var Item_1 = require("./Item");
require("./flexView.css");
var FlexView = /** @class */ (function (_super) {
    __extends(FlexView, _super);
    function FlexView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FlexView.prototype.getContentFlowClasses = function () {
        if (typeof this.props.flowDirection === 'undefined') {
            return [];
        }
        var flowDirection = this.props.flowDirection;
        return Object.keys(this.props.flowDirection).map(function (breakPoint) {
            var direction = flowDirection[breakPoint];
            return "flex-view-direction-".concat(breakPoint, "-").concat(direction);
        });
    };
    FlexView.prototype.getContentAlignmentClasses = function () {
        var vPrefix = this.props.column ? 'justify-content-' : 'align-items-';
        var hPrefix = this.props.column ? 'align-items-' : 'justify-content-';
        var vAlignContentClasses = {
            top: "".concat(vPrefix, "start"),
            center: "".concat(vPrefix, "center"),
            bottom: "".concat(vPrefix, "end"),
            stretch: "".concat(vPrefix, "stretch"),
        };
        var hAlignContentClasses = {
            left: "".concat(hPrefix, "start"),
            center: "".concat(hPrefix, "center"),
            right: "".concat(hPrefix, "end"),
            between: "".concat(hPrefix, "between"),
            around: "".concat(hPrefix, "around"),
            evenly: "".concat(hPrefix, "evenly"),
        };
        var vAlignContent = this.props.vAlignContent && vAlignContentClasses[this.props.vAlignContent];
        var hAlignContent = this.props.hAlignContent && hAlignContentClasses[this.props.hAlignContent];
        return (0, clsx_1.default)(vAlignContent, hAlignContent);
    };
    // eslint-disable-next-line @typescript-eslint/ban-types
    FlexView.prototype.buildGutters = function (gutters, positions) {
        if (positions === void 0) { positions = ['l', 'r', 't', 'b']; }
        if (typeof gutters === 'undefined') {
            return [];
        }
        var gutterDecorated = typeof gutters === 'string' ? { xs: gutters } : gutters;
        return Object.keys(gutterDecorated).reduce(function (carry, breakPoint) {
            positions.forEach(function (type) { return carry.push("gutters-".concat(breakPoint, "-").concat(type, "-").concat(gutterDecorated[breakPoint])); });
            return carry;
        }, []);
    };
    FlexView.prototype.getGutterClassByType = function (gutters, type) {
        var _this = this;
        var unionPositionToSubType = {
            tb: ['t', 'b'],
            lr: ['l', 'r'],
        };
        if (typeof gutters[type] !== 'undefined') {
            return this.buildGutters(gutters[type], [type]);
        }
        return unionPositionToSubType[type].reduce(function (carry, subType) { return carry.concat(_this.buildGutters(gutters[subType], [subType])); }, []);
    };
    FlexView.prototype.getGuttersClasses = function () {
        var gutters = this.props.gutters;
        if (typeof gutters === 'undefined') {
            return [];
        }
        if (typeof gutters === 'string') {
            return "gutters-".concat(gutters);
        }
        return []
            .concat(this.getGutterClassByType(gutters, 'tb'))
            .concat(this.getGutterClassByType(gutters, 'lr'));
    };
    FlexView.prototype.render = function () {
        var _this = this;
        return ((0, jsx_runtime_1.jsx)(react_1.ClassNames, { children: function (_a) {
                var css = _a.css;
                return ((0, jsx_runtime_1.jsx)("div", __assign({ className: clsx_1.default.apply(void 0, __spreadArray(__spreadArray(['flex-view',
                        _this.props.className,
                        _this.getGuttersClasses(),
                        _this.getContentAlignmentClasses()], _this.getContentFlowClasses(), false), [css(_this.props.style)], false)) }, (0, propsFilter_1.getAllDataProps)(_this.props, _this.context), { children: _this.props.children })));
            } }));
    };
    FlexView.Item = Item_1.Item;
    FlexView.contextType = SharkMorphContext_1.SharkMorphContext;
    return FlexView;
}(React.PureComponent));
exports.FlexView = FlexView;
FlexView.defaultProps = {
    column: false,
};
//# sourceMappingURL=FlexView.js.map